// Team collaboration helpers shared by the Builder and Make (CONTENT_HUB_REVIEW_DESK_2026-10-21, phase 1).
// Word diff for Versions › Compare: [{t, op: "same"|"add"|"del"}]. Plain LCS over words (pieces are short).
export function wordDiff(a, b) {
  const A = String(a || "").split(/(\s+)/).filter(x => x !== "");
  const B = String(b || "").split(/(\s+)/).filter(x => x !== "");
  if (A.length * B.length > 4000000) return [{
    t: a,
    op: "del"
  }, {
    t: b,
    op: "add"
  }];
  const n = A.length,
    m = B.length;
  const L = Array.from({
    length: n + 1
  }, () => new Uint16Array(m + 1));
  for (let i = n - 1; i >= 0; i--) for (let j = m - 1; j >= 0; j--) L[i][j] = A[i] === B[j] ? L[i + 1][j + 1] + 1 : Math.max(L[i + 1][j], L[i][j + 1]);
  const out = [];
  let i = 0,
    j = 0;
  const push = (t, op) => {
    const last = out[out.length - 1];
    if (last && last.op === op) last.t += t;else out.push({
      t,
      op
    });
  };
  while (i < n && j < m) {
    if (A[i] === B[j]) {
      push(A[i], "same");
      i++;
      j++;
    } else if (L[i + 1][j] >= L[i][j + 1]) {
      push(A[i], "del");
      i++;
    } else {
      push(B[j], "add");
      j++;
    }
  }
  while (i < n) push(A[i++], "del");
  while (j < m) push(B[j++], "add");
  return out;
}
export const nameOf = email => {
  const s = String(email || "").split("@")[0].replace(/[._-]+/g, " ").trim();
  return s ? s.replace(/\b\w/g, c => c.toUpperCase()) : "Someone";
};
export const initialsOf = email => nameOf(email).split(" ").filter(Boolean).slice(0, 2).map(w => w[0]).join("").toUpperCase() || "?";